module.exports = __webpack_public_path__ + "img/435.b8b058b9.jpg";